import { jsx as e, jsxs as z, Fragment as D } from "react/jsx-runtime";
import * as p from "@radix-ui/react-tooltip";
import { useControllableState as w } from "@radix-ui/react-use-controllable-state";
import { OverrideAppearance as B } from "@telegraph/appearance";
import { RefToTgphRef as q } from "@telegraph/helpers";
import { Stack as H } from "@telegraph/layout";
import { motion as J } from "@telegraph/motion";
import { Text as K } from "@telegraph/typography";
import a from "react";
const L = {
  light: {
    border: "px",
    shadow: "2"
  },
  dark: {}
}, O = a.createContext({
  groupOpen: !1,
  setGroupOpen: () => {
  }
}), Q = ({ open: r, delay: o = 600 }) => {
  const t = a.useContext(O);
  return a.useEffect(() => {
    let i = null;
    return t.setGroupOpen && (r === !0 && t.setGroupOpen(!0), r === !1 && (i = setTimeout(() => {
      t.setGroupOpen && t.setGroupOpen(!1);
    }, o))), () => {
      i && clearTimeout(i);
    };
  }, [r, t, o]), {
    groupOpen: t.groupOpen
  };
}, rt = ({ children: r }) => {
  const [o, t] = a.useState(!1);
  return /* @__PURE__ */ e(O.Provider, { value: { groupOpen: o, setGroupOpen: t }, children: r });
}, ot = ({
  // Radix Tooltip Provider Props
  delayDuration: r = 400,
  skipDelayDuration: o,
  disableHoverableContent: t,
  // Radix Tooltip Root Props
  defaultOpen: i,
  open: g,
  onOpenChange: T,
  // Radix Tooltip Content Props
  "aria-label": h,
  onEscapeKeyDown: x,
  onPointerDownOutside: y,
  forceMount: A,
  side: u = "bottom",
  sideOffset: C = 4,
  align: I = "center",
  alignOffset: F,
  avoidCollisions: N,
  collisionBoundary: v,
  collisionPadding: S,
  arrowPadding: G,
  sticky: E,
  hideWhenDetached: b,
  // Label Props
  label: s,
  labelProps: c,
  // Telegraph Props
  enabled: M = !0,
  appearance: f = "dark",
  children: l
}) => {
  const [d, P] = w({
    prop: g,
    onChange: T,
    defaultProp: i
  }), { groupOpen: m } = Q({ open: !!d, delay: r }), R = a.Children.toArray(l).some(
    (n) => n.props.disabled
  ), _ = m || R ? 0 : r, j = !m, k = (n) => {
    if (n === "top")
      return {
        y: -5
      };
    if (n === "bottom")
      return {
        y: 5
      };
    if (n === "left")
      return {
        x: -5
      };
    if (n === "right")
      return {
        x: 5
      };
  };
  return M ? /* @__PURE__ */ e(
    p.Provider,
    {
      delayDuration: _,
      skipDelayDuration: o,
      disableHoverableContent: t,
      children: /* @__PURE__ */ z(p.Root, { open: d, onOpenChange: P, children: [
        /* @__PURE__ */ e(p.Trigger, { asChild: !0, children: /* @__PURE__ */ e(q, { children: l }) }),
        /* @__PURE__ */ e(p.Portal, { children: /* @__PURE__ */ e(
          p.Content,
          {
            "aria-label": h,
            onEscapeKeyDown: x,
            onPointerDownOutside: y,
            forceMount: A,
            side: u,
            sideOffset: C,
            align: I,
            alignOffset: F,
            avoidCollisions: N,
            collisionBoundary: v,
            collisionPadding: S,
            arrowPadding: G,
            sticky: E,
            hideWhenDetached: b,
            style: {
              zIndex: "var(--tgph-zIndex-tooltip)"
            },
            children: /* @__PURE__ */ e(B, { appearance: f, asChild: !0, children: /* @__PURE__ */ e(
              H,
              {
                as: J.div,
                className: "tgph",
                initial: j ? {
                  opacity: 0,
                  scale: 0.5,
                  ...k(u)
                } : {},
                animate: {
                  opacity: 1,
                  scale: 1,
                  x: 0,
                  y: 0
                },
                transition: {
                  duration: 100,
                  type: "spring"
                },
                bg: "gray-1",
                rounded: "3",
                py: "2",
                px: "3",
                align: "center",
                justify: "center",
                style: {
                  transformOrigin: "var(--radix-tooltip-content-transform-origin)"
                },
                ...c ? { labelProps: c } : {},
                ...L[f],
                children: typeof s == "string" ? /* @__PURE__ */ e(K, { as: "span", size: "1", children: s }) : s
              }
            ) })
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ e(D, { children: l });
};
export {
  ot as Tooltip,
  rt as TooltipGroupProvider
};
//# sourceMappingURL=index.mjs.map
